import {
  Grid,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Typography,
  TableBody,
} from "@material-ui/core";
import React, { FunctionComponent } from "react";
import { financialItemStyles } from "./financialItemStyle";
import TableContainer from "@material-ui/core/TableContainer";
import "../Print.css";
type CardDataProps = {
  cardData: Array<object>;
  creditCardTotal: any;
};

export const CardSummary: FunctionComponent<CardDataProps> = ({
  cardData,
  creditCardTotal,
}) => {
  const classes = financialItemStyles();
  return (
    <Grid container>
      <Grid item xs={12}>
        <TableContainer>
          <Table
            className={classes.table}
            size="small"
            aria-label="a dense table"
          >
            <TableHead className={classes.tableRow}>
              <TableRow style={{ height: "3em" }}>
                <TableCell
                  align="left"
                  className={classes.headColor}
                  component="th"
                  scope="row"
                >
                  Card Type
                </TableCell>
                <TableCell
                  align="center"
                  className={classes.headColor}
                  component="th"
                  scope="row"
                >
                  Number of Transaction
                </TableCell>
                {/* <TableCell align="center" className={classes.headColor}>Sales Amount</TableCell>
            <TableCell align="center" className={classes.columnWeight}>Discount Amount</TableCell> */}
                <TableCell align="right" className={classes.headColor}>
                  Total Amount
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {cardData &&
                cardData.map((data: any) => (
                  <TableRow>
                    <TableCell align="left" className={classes.headColor}>
                      {data.card_name}
                    </TableCell>
                    <TableCell align="left" className={classes.tableColumn}>
                      {data.CreditCardCount}
                    </TableCell>
                    {/* <TableCell align="left"  className={classes.tablecontentSalesandCard}>0</TableCell>
                <TableCell align="left" className={classes.tableColumn}>0</TableCell> */}
                    <TableCell align="right" className={classes.columnWeight}>
                      {data.CreditCardAmount}
                    </TableCell>
                  </TableRow>
                ))}
                <TableRow style={{ height: "3em" }}>
                <TableCell align="left" className={classes.totalCellStyle}>
                  <Typography className={classes.total}>Total</Typography>
                </TableCell>
                <TableCell align="left" className={classes.middleTotalcell} />
                <TableCell align="right" className={classes.totalValueCell}>
                  <Typography className={classes.value}>
                  {creditCardTotal}
                  </Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
      {/* <Grid item xs={12}>
        <Grid container>
          <Grid item xs={6}>
            <Typography className={classes.total}>Total</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography className={classes.value}>{creditCardTotal}</Typography>
          </Grid>
        </Grid>
      </Grid> */}
    </Grid>
  );
};

